<div class="privacy-policy">
  <div class="container">
    <div class="privacy-policy__header">
      <h1>Privacy Policy</h1>
    </div>
    <div class="privacy-policy__content">
      <h2>Personal Information</h2>
      <p>
        We will not collect personal information about you when you visit TA DECIDE unless you
        choose to provide that information to us. If you choose to provide us with personal
        information, such as an email, we will only use that information to get you the information
        you have requested. It will not be stored. We do not collect personally identifiable
        information (full name, email address, SSN, or other unique identifiers) only if
        specifically and knowingly provided by you. We only share the information you give us with
        another government agency if your inquiry relates to that agency, or as otherwise required
        by law. We do not collect information for commercial marketing.
      </p>
      <h2>Cookies and Automatic Data Collection Technologies</h2>
      <p>
        A cookie is a small file of information which is stored on your computer. That cookie then
        communicates with servers, ours or those of other companies that we authorize to collect
        data for us, and allows recognition of your personal computer or other device you are using
        to access this website.
      </p>
      <p>
        Most modern browsers offer you ways to control or block cookies. These browser controls will
        usually be found in the “options” or “preferences” menu in your toolbar. The “help” portion
        of the toolbar on most browsers will tell you how to stop or manage cookies. More
        information is available here,
        <a href="https://www.allaboutcookies.org.">www.allaboutcookies.org.</a>
      </p>
    </div>
  </div>
</div>
